import { Box, Typography } from "@mui/material";
import { Trans } from "react-i18next";
import { iresoftColors } from "../../../theme/ireColors";

const QuoteSection: React.FC = () => {
  return (
    <Box
      width="100%"
      p={2}
      display="flex"
      flexDirection="column"
      alignItems="center"
      mb={3}
    >
      <Box
        sx={{
          maxWidth: 700,
          mx: "auto",
          my: 1,
          mb: -3,
          p: 4,
          borderRadius: 3,
          bgcolor: "background.paper",
          boxShadow: 3,
          textAlign: "center",
          position: "relative",
          "&::before": {
            content: '"“"',
            fontSize: 50,
            position: "absolute",
            top: -10,
            left: 10,
            color: iresoftColors.black40,
          },
          "&::after": {
            content: '"”"',
            fontSize: 50,
            position: "absolute",
            bottom: -30,
            right: 10,
            color: iresoftColors.black40,
          },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            lineHeight: 1.4,
            mt: 1,
          }}
        >
          <Trans
            i18nKey="pages.historyReading.ireSentence"
            components={{
              red: <span style={{ color: iresoftColors.iresoftRed }} />,
            }}
          />
        </Typography>
      </Box>
    </Box>
  );
};

export default QuoteSection;
